import React, { useMemo } from 'react';
import { ICredentials, IGetPaginatedCredentials } from 'types';
import { ISelectOption } from 'components/Select/types';
import { useFetchData } from 'hooks/useFetchData';
import { AxiosResponse } from 'axios';
import { getPaginatedCredentials } from 'backend/credentials';
import { FormSelectNew } from 'components/Select/FormSelectNew';

interface IProps {
	setVivaWalletCredentialsId: (value: Nullable<string>) => void;
}

export const VivaWalletCredentialsSelect: React.FC<IProps> = React.memo(({ setVivaWalletCredentialsId }) => {
	const { response, loading, refetch, responseError } = useFetchData<
		AxiosResponse<ICredentials>,
		IGetPaginatedCredentials
	>(getPaginatedCredentials, {
		pageNumber: 0,
		pageSize: 0,
		name: null,
		sortByName: null,
	});

	const options = useMemo<ISelectOption[]>(
		() =>
			response?.data.credentialItems.map((el) => ({
				id: el.id,
				name: el.name || '',
			})) || [],
		[response],
	);

	return (
		<FormSelectNew
			testId="VivaWalletCredentialsSelect"
			name="vivaWalletCredentialsId"
			label="ISVCredentialLabel"
			options={options}
			fetchError={responseError}
			loading={loading}
			onRefetch={refetch}
			onChange={setVivaWalletCredentialsId}
		/>
	);
});
